import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-modal-add-ckm-simulation',
    templateUrl: './modal-add-ckm-simulation.component.html',
    styleUrls: ['./modal-add-ckm-simulation.component.scss'],
    standalone: false
})
export class ModalAddCkmSimulationComponent {
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<ModalAddCkmSimulationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { projectId?: any }
  ) {}

  ngOnInit(): void {
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onStepChanged(stepIndex: number): void {
  }

  onGenerationStarted(): void {
  }

  onGenerationCompleted(): void {
  }

  onNavigation(destination: string): void {
    this.dialogRef.close(destination);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
